import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bg-white grid grid-cols-1 place-content-between w-full p-3 aspect-video"
}
const _hoisted_2 = { class: "flex flex-col flex-shrink" }
const _hoisted_3 = { class: "col-span-2 flex flex-shrink font-bold" }
const _hoisted_4 = { class: "col-span-2 flex flex-shrink text-sm" }
const _hoisted_5 = { class: "flex justify-between" }
const _hoisted_6 = { class: "basis-1/2 flex" }
const _hoisted_7 = {
  key: 1,
  class: "bg-next-gray-md grid grid-cols-1 place-content-between w-full p-3 aspect-video"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NextButton = _resolveComponent("NextButton")!

  return (_ctx.id && _ctx.cid)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.cliente), 1),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.sottotitolo), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_NextButton, {
              disabled: !_ctx.email,
              component: "a",
              href: `mailto:${_ctx.email}`,
              variant: "primary",
              class: "basis-1/2 px-3 flex items-center justify-center"
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createElementVNode("i", { class: "icon-paper_plane" }, null, -1)
              ])),
              _: 1
            }, 8, ["disabled", "href"]),
            _createVNode(_component_NextButton, {
              disabled: !_ctx.tel,
              component: "a",
              href: `tel:${_ctx.tel}`,
              variant: "primary",
              class: "basis-1/2 px-3 flex items-center justify-center ml-3"
            }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createElementVNode("i", { class: "icon-telefono" }, null, -1)
              ])),
              _: 1
            }, 8, ["disabled", "href"])
          ]),
          _createVNode(_component_NextButton, {
            component: "router-link",
            variant: "outline-secondary",
            to: {name:'DettaglioContatto', params:{id:_ctx.id, cid:_ctx.cid}},
            class: "px-3 py-1 text-xs"
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createTextVNode("Vedi")
            ])),
            _: 1
          }, 8, ["to"])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_7))
}